import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-hotels min-h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_3 = { class: "relative z-10 w-full max-w-md rounded-2xl bg-white p-6 shadow-warm-lg" }
const _hoisted_4 = { class: "mb-4 flex items-start justify-between" }
const _hoisted_5 = { class: "mt-5 flex justify-end gap-3" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "inline-flex items-center"
}
const _hoisted_9 = { style: {"display":"none"} }
const _hoisted_10 = { class: "relative overflow-hidden bg-gradient-to-br from-primary-700 via-primary-600 to-gold-600 text-white" }
const _hoisted_11 = { class: "relative mx-auto max-w-6xl px-4 py-16 sm:px-6 md:py-20" }
const _hoisted_12 = { class: "py-4 text-center" }
const _hoisted_13 = { class: "flex justify-center" }
const _hoisted_14 = { class: "w-full max-w-3xl rounded-2xl bg-white p-3 shadow-warm-lg" }
const _hoisted_15 = { class: "grid grid-cols-1 gap-2 md:grid-cols-12" }
const _hoisted_16 = { class: "md:col-span-7" }
const _hoisted_17 = { class: "md:col-span-2" }
const _hoisted_18 = { class: "md:col-span-3" }
const _hoisted_19 = {
  key: 0,
  class: "border-b-4 border-primary-500 bg-cream-100 py-14 md:py-20"
}
const _hoisted_20 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_21 = { class: "rounded-2xl border border-sand-200 bg-white shadow-warm-lg" }
const _hoisted_22 = { class: "p-6 md:p-8" }
const _hoisted_23 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_24 = { class: "mb-6 grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_25 = { class: "col-span-1" }
const _hoisted_26 = { class: "h-full rounded-2xl border border-primary-200 bg-primary-50 p-6" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "mt-3 rounded-lg bg-white p-3 text-sm text-ink-800"
}
const _hoisted_29 = {
  key: 1,
  class: "mt-3 rounded-lg bg-red-50 p-3 text-sm text-red-600"
}
const _hoisted_30 = { class: "col-span-1" }
const _hoisted_31 = { class: "h-full rounded-2xl border border-gold-200 bg-gold-50 p-6" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "mb-6" }
const _hoisted_39 = {
  key: 1,
  class: "bg-white py-14 md:py-20"
}
const _hoisted_40 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_41 = {
  key: 0,
  class: "py-14 text-center"
}
const _hoisted_42 = {
  key: 1,
  class: "py-14 text-center"
}
const _hoisted_43 = {
  key: 2,
  class: "featured-hotels-scroll"
}
const _hoisted_44 = { class: "featured-hotels-container" }
const _hoisted_45 = {
  key: 2,
  class: "bg-cream-100 py-14 md:py-20"
}
const _hoisted_46 = {
  key: 3,
  class: "bg-cream-100 py-14 md:py-20"
}
const _hoisted_47 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_48 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_49 = { class: "mb-0 text-ink-500" }
const _hoisted_50 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_51 = { class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_52 = {
  key: 0,
  class: "mt-6 text-center"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_55 = {
  key: 1,
  class: "inline-flex items-center"
}
const _hoisted_56 = {
  key: 4,
  class: "bg-white py-14 md:py-20"
}
const _hoisted_57 = {
  key: 5,
  class: "bg-white py-14 md:py-20"
}
const _hoisted_58 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_59 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_60 = { class: "mb-1 font-display text-2xl font-semibold text-ink-900" }
const _hoisted_61 = { class: "mb-0 text-ink-500" }
const _hoisted_62 = { class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_63 = {
  key: 0,
  class: "mt-6 text-center"
}
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 6,
  class: "bg-white py-14 md:py-20"
}
const _hoisted_68 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_69 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertyCard = _resolveComponent("PropertyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLocationModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-ink-900/50",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissLocationModal && _ctx.dismissLocationModal(...args)))
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "font-display text-lg font-semibold text-ink-900" }, [
                _createElementVNode("i", { class: "bi bi-geo-alt-fill mr-2 text-primary-600" }),
                _createTextVNode(" Enable Location Services ")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "text-ink-400 transition-colors hover:text-ink-700",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismissLocationModal && _ctx.dismissLocationModal(...args))),
                "aria-label": "Close"
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))])
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "mb-3 text-sm text-ink-700" }, " To provide you with the best experience and show nearby hotels, we need access to your location. "),
              _createElementVNode("div", { class: "rounded-lg border border-sand-200 bg-cream-100 p-4 text-sm text-ink-700" }, [
                _createElementVNode("i", { class: "bi bi-info-circle mr-2 text-primary-600" }),
                _createElementVNode("strong", null, "Benefits:"),
                _createElementVNode("ul", { class: "mb-0 mt-2 list-disc space-y-1 pl-5" }, [
                  _createElementVNode("li", null, "Find hotels near you automatically"),
                  _createElementVNode("li", null, "Get accurate distance information"),
                  _createElementVNode("li", null, "Personalized search results")
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-lg border border-sand-300 px-5 py-2.5 text-sm font-semibold text-ink-700 hover:bg-cream-100",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismissLocationModal && _ctx.dismissLocationModal(...args)))
              }, " Not Now "),
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex items-center justify-center rounded-lg bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white shadow-warm-sm transition-colors hover:bg-primary-600 disabled:opacity-60",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enableLocation && _ctx.enableLocation(...args))),
                disabled: _ctx.loadingLocation
              }, [
                (_ctx.loadingLocation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("span", { class: "spinner spinner-sm mr-2" }, null, -1),
                      _createTextVNode(" Getting Location... ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "bi bi-geo-alt-fill mr-2" }, null, -1),
                      _createTextVNode(" Enable Location ", -1)
                    ]))]))
              ], 8, _hoisted_6)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _cache[24] || (_cache[24] = _createElementVNode("h1", null, "Hotels and Apartments Search - Roomsvile", -1)),
      _createElementVNode("p", null, " Find and book hotels, serviced apartments, and vacation rentals in " + _toDisplayString(_ctx.selectedCityName || "your area") + ". Best prices guaranteed. Search by location, state, or city. ", 1)
    ]),
    _createElementVNode("section", _hoisted_10, [
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "pointer-events-none absolute inset-0 opacity-10" }, [
        _createElementVNode("div", { class: "absolute -left-48 top-0 h-96 w-96 rotate-45 rounded-full bg-white" }),
        _createElementVNode("div", { class: "absolute bottom-0 right-0 h-96 w-96 -rotate-45 rounded-full bg-white" })
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[25] || (_cache[25] = _createElementVNode("h1", { class: "mb-3 font-display text-4xl font-semibold text-white sm:text-5xl" }, " Discover Your Perfect Stay ", -1)),
          _cache[26] || (_cache[26] = _createElementVNode("p", { class: "mb-3 text-lg text-white/90" }, " Book directly with hotels and apartments. No middleman, no extra fees. ", -1)),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mb-6 flex items-center justify-center gap-2 font-semibold text-gold-200" }, [
            _createElementVNode("i", { class: "bi bi-patch-check-fill text-lg" }),
            _createElementVNode("span", null, "Direct Booking • Best Prices • No Hidden Fees")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quickSearchQuery) = $event)),
                    type: "text",
                    placeholder: "Enter city, state, or property name...",
                    class: "w-full rounded-lg border border-sand-300 bg-white px-4 py-2.5 text-sm text-ink-800 placeholder:text-ink-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100",
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.performQuickSearch && _ctx.performQuickSearch(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.quickSearchQuery]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAdvancedSearch && _ctx.toggleAdvancedSearch(...args))),
                    class: "w-full rounded-lg border border-sand-300 px-5 py-2.5 text-sm font-semibold text-ink-700 hover:bg-cream-100"
                  }, " Filters ")
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.performQuickSearch && _ctx.performQuickSearch(...args))),
                    class: "inline-flex w-full items-center justify-center rounded-lg bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white shadow-warm-sm transition-colors hover:bg-primary-600"
                  }, " Search ")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.showAdvancedSearch)
          ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "font-display text-2xl font-semibold text-ink-900" }, " Advanced Search ", -1)),
                      _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleAdvancedSearch && _ctx.toggleAdvancedSearch(...args))),
                        class: "text-ink-400 transition-colors hover:text-ink-700"
                      }, [...(_cache[29] || (_cache[29] = [
                        _createElementVNode("svg", {
                          class: "h-6 w-6",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          width: "24",
                          height: "24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "mb-4 flex items-center font-display text-lg font-semibold text-ink-900" }, [
                            _createElementVNode("svg", {
                              class: "mr-2 h-6 w-6 text-primary-600",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              width: "24",
                              height: "24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                              }),
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                              })
                            ]),
                            _createTextVNode(" Search Nearby ")
                          ], -1)),
                          _createElementVNode("button", {
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.searchByLocation && _ctx.searchByLocation(...args))),
                            disabled: _ctx.loadingLocation,
                            class: "inline-flex w-full items-center justify-center rounded-lg bg-primary-500 py-3 text-sm font-semibold text-white shadow-warm-sm transition-colors hover:bg-primary-600 disabled:opacity-60"
                          }, _toDisplayString(_ctx.loadingLocation
                          ? "Getting Location..."
                          : "Use My Location"), 9, _hoisted_27),
                          (_ctx.currentLocation)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_28, " 📍 " + _toDisplayString(_ctx.currentLocation), 1))
                            : _createCommentVNode("", true),
                          (_ctx.locationError)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.locationError), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "mb-4 flex items-center font-display text-lg font-semibold text-ink-900" }, [
                            _createElementVNode("svg", {
                              class: "mr-2 h-6 w-6 text-primary-600",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              width: "24",
                              height: "24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                              })
                            ]),
                            _createTextVNode(" Search by Location ")
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_32, [
                              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-ink-700" }, "Select State", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedState) = $event)),
                                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onStateChange && _ctx.onStateChange(...args))),
                                class: "w-full rounded-lg border border-sand-300 bg-white px-4 py-2.5 text-sm text-ink-800 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100",
                                disabled: _ctx.locationStore.isLoadingStates
                              }, [
                                _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Choose a state...", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationStore.states, (state) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: state.id,
                                    value: state.id
                                  }, _toDisplayString(state.name), 9, _hoisted_34))
                                }), 128))
                              ], 40, _hoisted_33), [
                                [_vModelSelect, _ctx.selectedState]
                              ])
                            ]),
                            (_ctx.selectedState)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-ink-700" }, "Select City", -1)),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedCity) = $event)),
                                    class: "w-full rounded-lg border border-sand-300 bg-white px-4 py-2.5 text-sm text-ink-800 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100",
                                    disabled: _ctx.locationStore.isLoadingCities
                                  }, [
                                    _cache[34] || (_cache[34] = _createElementVNode("option", { value: "" }, "Choose a city...", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationStore.cities, (city) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: city.id,
                                        value: city.id
                                      }, _toDisplayString(city.name), 9, _hoisted_37))
                                    }), 128))
                                  ], 8, _hoisted_36), [
                                    [_vModelSelect, _ctx.selectedCity]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-ink-700" }, "Property Type", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.propertyType) = $event)),
                        class: "w-full rounded-lg border border-sand-300 bg-white px-4 py-2.5 text-sm text-ink-800 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                      }, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("option", { value: "" }, "All Types", -1),
                        _createElementVNode("option", { value: "1" }, "Hotels", -1),
                        _createElementVNode("option", { value: "2" }, "Apartments", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.propertyType]
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.searchHotels && _ctx.searchHotels(...args))),
                      class: "inline-flex w-full items-center justify-center rounded-lg bg-primary-500 py-3 text-base font-semibold text-white shadow-warm-sm transition-colors hover:bg-primary-600"
                    }, " Apply Filters & Search ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.hasSearched)
      ? (_openBlock(), _createElementBlock("section", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "mb-6" }, [
              _createElementVNode("h2", { class: "mb-1 font-display text-2xl font-semibold text-ink-900" }, " Featured Properties "),
              _createElementVNode("p", { class: "text-ink-500" }, " Hotels, apartments, and vacation rentals listed by property owners ")
            ], -1)),
            (_ctx.loadingFeaturedHotels)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [...(_cache[39] || (_cache[39] = [
                  _createElementVNode("div", {
                    class: "spinner",
                    role: "status",
                    "aria-label": "Loading"
                  }, null, -1),
                  _createElementVNode("p", { class: "mt-3 text-ink-500" }, "Loading featured hotels...", -1)
                ]))]))
              : (_ctx.featuredHotels.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[40] || (_cache[40] = [
                    _createElementVNode("i", { class: "bi bi-building mb-3 text-5xl text-ink-300" }, null, -1),
                    _createElementVNode("p", { class: "text-ink-500" }, " No featured hotels available at the moment. ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuredHotels, (hotel) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'featured-' + hotel.id,
                          class: "featured-hotel-card"
                        }, [
                          _createVNode(_component_PropertyCard, {
                            hotel: hotel,
                            "is-favourite": _ctx.favouritesStore.isFavourite(hotel.id),
                            "favourite-pending": _ctx.favouritesStore.isPending(hotel.id),
                            onToggleFavourite: _ctx.toggleFavourite
                          }, null, 8, ["hotel", "is-favourite", "favourite-pending", "onToggleFavourite"])
                        ]))
                      }), 128))
                    ])
                  ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hasSearched && _ctx.isLoadingNearby && _ctx.nearbyHotels.length === 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_45, [...(_cache[42] || (_cache[42] = [
          _createElementVNode("div", { class: "mx-auto max-w-6xl px-4 sm:px-6" }, [
            _createElementVNode("div", { class: "py-14 text-center" }, [
              _createElementVNode("div", {
                class: "spinner",
                role: "status",
                "aria-label": "Loading"
              }),
              _createElementVNode("p", { class: "mt-3 text-ink-500" }, "Finding properties near you...")
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!_ctx.hasSearched && _ctx.nearbyHotels.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", null, [
                _cache[44] || (_cache[44] = _createElementVNode("h2", { class: "mb-1 font-display text-2xl font-semibold text-ink-900" }, " Properties Near You ", -1)),
                _createElementVNode("p", _hoisted_49, [
                  _cache[43] || (_cache[43] = _createTextVNode(" Based on your current location ", -1)),
                  (_ctx.nearbyPagination)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, " (Showing " + _toDisplayString(_ctx.nearbyHotels.length) + " of " + _toDisplayString(_ctx.nearbyPagination.totalRecords) + ") ", 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearbyHotels, (hotel) => {
                return (_openBlock(), _createBlock(_component_PropertyCard, {
                  key: 'nearby-' + hotel.id,
                  hotel: hotel,
                  "is-favourite": _ctx.favouritesStore.isFavourite(hotel.id),
                  "favourite-pending": _ctx.favouritesStore.isPending(hotel.id),
                  onToggleFavourite: _ctx.toggleFavourite
                }, null, 8, ["hotel", "is-favourite", "favourite-pending", "onToggleFavourite"]))
              }), 128))
            ]),
            (_ctx.hasMoreNearbyPages)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("button", {
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.loadMoreNearbyHotels && _ctx.loadMoreNearbyHotels(...args))),
                    disabled: _ctx.isLoadingNearby,
                    class: "rounded-lg border border-sand-300 px-8 py-3 text-base font-semibold text-ink-700 hover:bg-cream-100 disabled:opacity-60"
                  }, [
                    (_ctx.isLoadingNearby)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, [...(_cache[45] || (_cache[45] = [
                          _createElementVNode("span", { class: "spinner spinner-sm mr-2" }, null, -1),
                          _createTextVNode(" Loading... ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_55, [...(_cache[46] || (_cache[46] = [
                          _createTextVNode(" Load More Hotels ", -1),
                          _createElementVNode("i", { class: "bi bi-arrow-down-circle ml-2" }, null, -1)
                        ]))]))
                  ], 8, _hoisted_53)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasSearched && _ctx.isLoadingNearby)
      ? (_openBlock(), _createElementBlock("section", _hoisted_56, [...(_cache[47] || (_cache[47] = [
          _createElementVNode("div", { class: "mx-auto max-w-6xl px-4 sm:px-6" }, [
            _createElementVNode("div", { class: "py-14 text-center" }, [
              _createElementVNode("div", {
                class: "spinner",
                role: "status",
                "aria-label": "Loading"
              }),
              _createElementVNode("p", { class: "mt-3 text-ink-500" }, "Searching for properties...")
            ])
          ], -1)
        ]))]))
      : (_ctx.hasSearched && _ctx.nearbyHotels.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", _hoisted_60, _toDisplayString(_ctx.nearbyPagination?.totalRecords || _ctx.nearbyHotels.length) + " Properties Found ", 1),
                  _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.selectedCityName
                  ? `in ${_ctx.selectedCityName}, ${_ctx.selectedStateName}`
                  : "near you") + " • Direct booking available ", 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "rounded-lg border border-sand-300 px-5 py-2.5 text-sm font-semibold text-ink-700 hover:bg-cream-100"
                }, [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("i", { class: "bi bi-x-circle mr-1" }, null, -1),
                  _createTextVNode(" Clear Search ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_62, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearbyHotels, (hotel) => {
                  return (_openBlock(), _createBlock(_component_PropertyCard, {
                    key: 'result-' + hotel.id,
                    hotel: hotel,
                    "is-favourite": _ctx.favouritesStore.isFavourite(hotel.id),
                    "favourite-pending": _ctx.favouritesStore.isPending(hotel.id),
                    onToggleFavourite: _ctx.toggleFavourite
                  }, null, 8, ["hotel", "is-favourite", "favourite-pending", "onToggleFavourite"]))
                }), 128))
              ]),
              (_ctx.hasMoreNearbyPages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.loadMoreNearbyHotels && _ctx.loadMoreNearbyHotels(...args))),
                      disabled: _ctx.isLoadingNearby,
                      class: "rounded-lg border border-sand-300 px-5 py-2.5 text-sm font-semibold text-ink-700 hover:bg-cream-100 disabled:opacity-60"
                    }, [
                      (_ctx.isLoadingNearby)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, [...(_cache[49] || (_cache[49] = [
                            _createElementVNode("span", { class: "spinner spinner-sm mr-2" }, null, -1),
                            _createTextVNode(" Loading... ", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_66, " Load More Properties "))
                    ], 8, _hoisted_64)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.hasSearched && _ctx.nearbyHotels.length === 0 && !_ctx.isLoadingNearby)
          ? (_openBlock(), _createElementBlock("section", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _cache[50] || (_cache[50] = _createElementVNode("i", { class: "bi bi-search mb-3 text-5xl text-ink-300" }, null, -1)),
                  _cache[51] || (_cache[51] = _createElementVNode("h2", { class: "mb-3 font-display text-2xl font-semibold text-ink-900" }, " No Properties Found ", -1)),
                  _cache[52] || (_cache[52] = _createElementVNode("p", { class: "mb-6 text-ink-500" }, " We couldn't find any properties matching your criteria. Try adjusting your filters. ", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                    class: "inline-flex items-center justify-center rounded-lg bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white shadow-warm-sm transition-colors hover:bg-primary-600"
                  }, " Clear Search ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}